import { generateKlerpOrderPdf } from "./klerpOrderPdfShared";

const createCustomerInvoice = async (original) => {
    try {
        await generateKlerpOrderPdf(original, {
            referenceLabel: "INVOICE ID:",
            showPaymentBreakdown: true,
            includeAppendix: original.sstIncluded === true,
            downloadFileName: `${original.invoiceId}-${original.userId.name}`,
        });
    } catch (err) {
        alert("Failed");
        console.log(err);
    }
};

export default createCustomerInvoice;
